import * as RadixDialog from '@radix-ui/react-dialog';
import React, { useState } from 'react';

import { BaseButton } from '../../../../components/button/BaseButton';
import { getDisplayError } from '@utils/get-display-error';
import { CustomError } from 'src/error';
import { countSelfBills, type ISelfBillKindConfig } from '../self-bill-kind-config';

interface IBulkConvertToPurchasesConfirmDialogProps {
  config: ISelfBillKindConfig;
  isOpen: boolean;
  onClose: () => void;
  sentCount: number;
  isBusy: boolean;
  onConvert: () => Promise<void>;
}

export const BulkConvertToPurchasesConfirmDialog: React.FC<IBulkConvertToPurchasesConfirmDialogProps> = (props) => {
  const { config, isOpen, onClose, sentCount, isBusy, onConvert } = props;
  const [error, setError] = useState('');

  const run = async () => {
    setError('');
    try {
      await onConvert();
    } catch (err) {
      setError(err instanceof CustomError ? err.message : getDisplayError(err));
    }
  };

  const noun = countSelfBills(config, sentCount);

  return (
    <RadixDialog.Root open={isOpen} onOpenChange={(open) => !open && !isBusy && onClose()}>
      <RadixDialog.Portal>
        <RadixDialog.Overlay className="dialog-overlay" />
        <RadixDialog.Content className="dialog-content">
          <RadixDialog.Title className="heading-one mb-4">{`${noun} omzetten naar AKF?`}</RadixDialog.Title>

          <RadixDialog.Description className="mb-4">
            {`Maakt een aankoopfactuur aan voor de geselecteerde verzonden ${config.pluralName} zonder aankoopfactuur.`}
          </RadixDialog.Description>

          {error && <div className="text-sm text-negative-text mb-2 w-full whitespace-pre-line">{error}</div>}

          <div className="flex justify-between">
            <div>
              <BaseButton
                isLoading={isBusy}
                disabled={isBusy}
                onClick={(event) => {
                  event.preventDefault();
                  event.stopPropagation();
                  onClose();
                }}
              >
                Annuleer
              </BaseButton>
            </div>
            <BaseButton
              color="primary"
              isLoading={isBusy}
              disabled={isBusy}
              onClick={(event) => {
                event.preventDefault();
                event.stopPropagation();
                run();
              }}
            >
              Omzetten naar AKF
            </BaseButton>
          </div>
        </RadixDialog.Content>
      </RadixDialog.Portal>
    </RadixDialog.Root>
  );
};
